import { render, staticRenderFns } from "./HistoryLogs.vue?vue&type=template&id=9a941c6c&scoped=true&"
import script from "./HistoryLogs.vue?vue&type=script&lang=js&"
export * from "./HistoryLogs.vue?vue&type=script&lang=js&"
import style0 from "./HistoryLogs.css?vue&type=style&index=0&id=9a941c6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a941c6c",
  null
  
)

export default component.exports